import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxCardAttachment from "src/components/card/SfxCardAttachment.vue"
import SfxEmptyPage from "src/components/empty/SfxEmptyPage.vue"
import SfxTopNavigation from "src/components/navigation/SfxTopNavigation.vue"
import SfxSearchBar from "src/components/search/SfxSearchBar.vue"
import SfxSkeleton from "src/components/special/SfxSkeleton.vue"
import { useSearchStore } from "src/stores/searchStore"
import { SFX_CARD_ATTACHMENT_HEIGHT } from "src/util/constants/configurations"
import { EmptyStates } from "src/util/constants/emptyStates"
import { ContextAction, MissingEntityType } from "src/util/enums/entityType"
import { NavigationAction } from "src/util/enums/topNavigation"
import { SearchMap } from "src/util/search/searchMap"
import { Attachment } from "src/util/types/dataModels/attachment"
import { computed, onMounted, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogListAttachmentSelect',
  props: {
  entity: {
    type: String,
    required: true,
  },

  entityDesignation: {
    type: String,
    required: true,
  },

  attachmentList: {
    type: Array as PropType<Attachment[]>,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { t } = useI18n()
const searchStore = useSearchStore()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const subtitle = t("sfxDialogAddAttachments.subtitle", { entity: props.entity })

const searchMap = computed(() => {
  return new SearchMap<Attachment, Attachment>(
    (attachment) => [{ term: attachment.name, value: attachment }],
    {},
    props.attachmentList
  )
})

const filteredAttachments = computed<Attachment[] | undefined>(() => {
  return searchStore.term
    ? searchMap.value.getPartialMatches(searchStore.term)
    : props.attachmentList
})

const searchBarDisabled = computed(
  () => !searchStore.enabled || (props.attachmentList && props.attachmentList.length === 0)
)

//endregion

//region Lifecycle

onMounted(() => {
  searchStore.enabled = true
  searchStore.domain = "attachments"
})

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-list-manager",
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_unref(searchStore).term = null))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(SfxTopNavigation, {
            title: props.entityDesignation,
            "title-class": "text-h4",
            "subtitle-class": "text-subtitle2",
            "navigation-action": _unref(NavigationAction).CLOSE,
            "quick-action": _unref(ContextAction).ADD_ATTACHMENT,
            onClose: _unref(onDialogCancel),
            onContextSelect: _cache[0] || (_cache[0] = ($event: any) => (_unref(onDialogOK)(undefined))),
            class: "shadow",
            "hide-notifications": "",
            "hide-separator": "",
            "hide-context-menu": ""
          }, {
            subtitle: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _unref(subtitle) }, null, 8, _hoisted_1)
            ]),
            _: 1
          }, 8, ["title", "navigation-action", "quick-action", "onClose"]),
          _createVNode(SfxSearchBar, {
            class: "q-toolbar",
            disable: searchBarDisabled.value
          }, null, 8, ["disable"]),
          _createVNode(_component_q_card_section, { class: "sfx-dialog-list-manager-elements" }, {
            default: _withCtx(() => [
              (!filteredAttachments.value)
                ? (_openBlock(), _createBlock(SfxSkeleton, {
                    key: 0,
                    height: _unref(SFX_CARD_ATTACHMENT_HEIGHT),
                    "no-of-cards": 3
                  }, null, 8, ["height"]))
                : (filteredAttachments.value.length === 0)
                  ? (_openBlock(), _createBlock(SfxEmptyPage, {
                      key: 1,
                      class: "q-py-xl",
                      missingEntity: _unref(EmptyStates).get(_unref(MissingEntityType).ATTACHMENT_NO_MATCHES)
                    }, null, 8, ["missingEntity"]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filteredAttachments.value, (attachment, index) => {
                      return (_openBlock(), _createBlock(SfxCardAttachment, {
                        key: index,
                        attachment: attachment,
                        entity: props.entity,
                        onClick: ($event: any) => (_unref(onDialogOK)(attachment))
                      }, null, 8, ["attachment", "entity", "onClick"]))
                    }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})